import * as Types from '../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import { BulkUploadValidationFragmentFragmentDoc } from '../../../../_lib/bulk-operations/__generated__/queries.gql';
import { BulkUploadResultFragmentFragmentDoc } from '../../../../_lib/bulk-operations/__generated__/queries.gql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ValidatePriceBulkUploadQueryVariables = Types.Exact<{
  input: Types.PriceBulkUploadInput;
}>;


export type ValidatePriceBulkUploadQuery = { readonly __typename?: 'Query', readonly priceListV2: { readonly __typename?: 'PriceListV2Queries', readonly validatePriceBulkUpload: { readonly __typename?: 'BulkUploadValidationResult', readonly totalSent: number, readonly totalAdditions: number, readonly totalUpdates: number, readonly totalErrors: number, readonly items: ReadonlyArray<{ readonly __typename?: 'BulkUploadItemValidationResult', readonly id: string, readonly isUpdate?: boolean | null, readonly isAddition?: boolean | null, readonly hasError?: boolean | null, readonly errorMessage?: string | null, readonly unflattenedValue?: unknown | null, readonly validationBreakdown?: unknown | null }> } } };

export type PriceBulkUploadMutationVariables = Types.Exact<{
  input: Types.PriceBulkUploadInput;
}>;


export type PriceBulkUploadMutation = { readonly __typename?: 'Mutation', readonly priceListV2: { readonly __typename?: 'PriceListV2Mutations', readonly priceBulkUpload: { readonly __typename?: 'BulkUploadResult', readonly totalSent: number, readonly totalAdditions: number, readonly totalUpdates: number, readonly totalErrors: number, readonly errors: ReadonlyArray<{ readonly __typename?: 'BulkUploadError', readonly id: string, readonly unflattenedData?: unknown | null, readonly errorMessage?: string | null }> } } };

export type PriceBulkDownloadQueryVariables = Types.Exact<{
  input: Types.PriceBulkDownloadInput;
}>;


export type PriceBulkDownloadQuery = { readonly __typename?: 'Query', readonly priceListV2: { readonly __typename?: 'PriceListV2Queries', readonly priceBulkDownload: { readonly __typename?: 'BulkDownloadResult', readonly csv: string, readonly totalCount: number } } };


export const ValidatePriceBulkUploadDocument = gql`
    query validatePriceBulkUpload($input: PriceBulkUploadInput!) {
  priceListV2 {
    validatePriceBulkUpload(input: $input) {
      ...BulkUploadValidationFragment
    }
  }
}
    ${BulkUploadValidationFragmentFragmentDoc}`;

/**
 * __useValidatePriceBulkUploadQuery__
 *
 * To run a query within a React component, call `useValidatePriceBulkUploadQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidatePriceBulkUploadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidatePriceBulkUploadQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidatePriceBulkUploadQuery(baseOptions: Apollo.QueryHookOptions<ValidatePriceBulkUploadQuery, ValidatePriceBulkUploadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidatePriceBulkUploadQuery, ValidatePriceBulkUploadQueryVariables>(ValidatePriceBulkUploadDocument, options);
      }
export function useValidatePriceBulkUploadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidatePriceBulkUploadQuery, ValidatePriceBulkUploadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidatePriceBulkUploadQuery, ValidatePriceBulkUploadQueryVariables>(ValidatePriceBulkUploadDocument, options);
        }
export type ValidatePriceBulkUploadQueryHookResult = ReturnType<typeof useValidatePriceBulkUploadQuery>;
export type ValidatePriceBulkUploadLazyQueryHookResult = ReturnType<typeof useValidatePriceBulkUploadLazyQuery>;
export type ValidatePriceBulkUploadQueryResult = Apollo.QueryResult<ValidatePriceBulkUploadQuery, ValidatePriceBulkUploadQueryVariables>;
export const PriceBulkUploadDocument = gql`
    mutation priceBulkUpload($input: PriceBulkUploadInput!) {
  priceListV2 {
    priceBulkUpload(input: $input) {
      ...BulkUploadResultFragment
    }
  }
}
    ${BulkUploadResultFragmentFragmentDoc}`;
export type PriceBulkUploadMutationFn = Apollo.MutationFunction<PriceBulkUploadMutation, PriceBulkUploadMutationVariables>;

/**
 * __usePriceBulkUploadMutation__
 *
 * To run a mutation, you first call `usePriceBulkUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePriceBulkUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [priceBulkUploadMutation, { data, loading, error }] = usePriceBulkUploadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePriceBulkUploadMutation(baseOptions?: Apollo.MutationHookOptions<PriceBulkUploadMutation, PriceBulkUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PriceBulkUploadMutation, PriceBulkUploadMutationVariables>(PriceBulkUploadDocument, options);
      }
export type PriceBulkUploadMutationHookResult = ReturnType<typeof usePriceBulkUploadMutation>;
export type PriceBulkUploadMutationResult = Apollo.MutationResult<PriceBulkUploadMutation>;
export type PriceBulkUploadMutationOptions = Apollo.BaseMutationOptions<PriceBulkUploadMutation, PriceBulkUploadMutationVariables>;
export const PriceBulkDownloadDocument = gql`
    query priceBulkDownload($input: PriceBulkDownloadInput!) {
  priceListV2 {
    priceBulkDownload(input: $input) {
      csv
      totalCount
    }
  }
}
    `;

/**
 * __usePriceBulkDownloadQuery__
 *
 * To run a query within a React component, call `usePriceBulkDownloadQuery` and pass it any options that fit your needs.
 * When your component renders, `usePriceBulkDownloadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePriceBulkDownloadQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePriceBulkDownloadQuery(baseOptions: Apollo.QueryHookOptions<PriceBulkDownloadQuery, PriceBulkDownloadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PriceBulkDownloadQuery, PriceBulkDownloadQueryVariables>(PriceBulkDownloadDocument, options);
      }
export function usePriceBulkDownloadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PriceBulkDownloadQuery, PriceBulkDownloadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PriceBulkDownloadQuery, PriceBulkDownloadQueryVariables>(PriceBulkDownloadDocument, options);
        }
export type PriceBulkDownloadQueryHookResult = ReturnType<typeof usePriceBulkDownloadQuery>;
export type PriceBulkDownloadLazyQueryHookResult = ReturnType<typeof usePriceBulkDownloadLazyQuery>;
export type PriceBulkDownloadQueryResult = Apollo.QueryResult<PriceBulkDownloadQuery, PriceBulkDownloadQueryVariables>;